"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TipoSeleccion;
(function (TipoSeleccion) {
    TipoSeleccion["ACCESO_NODO_RAIZ"] = "ACCESO_NODO_RAIZ";
    TipoSeleccion["SELECT_NODOS_FROM_NODO"] = "SELECT_NODOS_FROM_NODO";
    TipoSeleccion["ERROR_SINTACTICO"] = "ERROR_SINTACTICO";
    TipoSeleccion["ERROR_LEXICO"] = "ERROR_LEXICO";
    TipoSeleccion["ERROR_SEMANTICO"] = "ERROR_SEMANTICO";
})(TipoSeleccion = exports.TipoSeleccion || (exports.TipoSeleccion = {}));
